import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8h8","key":"svg-0"}],["path",{"d":"M20 11.5v6.5a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6.5","key":"svg-1"}],["path",{"d":"M8 4v4","key":"svg-2"}],["path",{"d":"M16 8l5 -5","key":"svg-3"}],["path",{"d":"M21 7.5v-4.5h-4.5","key":"svg-4"}]]

const IconBrowserMaximize = createReactComponent('outline', 'browser-maximize', 'BrowserMaximize', __iconNode);

export default IconBrowserMaximize;